import { useEffect } from "react";
import initPropAnim from "./propanim";
import { FaPlay, FaChevronLeft, FaChevronRight } from "react-icons/fa"
import ToSearchButton from "../Common/ToSearchButton";
import SearchBar from "./SearchBar";
import FancyButton from "../Common/FancyButton";





function PropShow({ page, text }) {
    useEffect(() => {
        initPropAnim();
        console.log("Added listenere");
    }, []);

    var propImageLen;
    switch (page) {
        case "welcome":
            propImageLen = 19;
            break;
        case "search":
            propImageLen = 14;
            break;
        case "purchases":
            propImageLen = 27;
            break;
        case "service":
            propImageLen = 32;
            break;
        case "region":
            propImageLen = 18;
            break;
        case "lifestyle":
            propImageLen = 18;
            break;
    }

    return (

        <div className="row propshow-cnt cursor-pointer">
            <div className="propshow-slideshow">
                <div id="propshow-slideshow-frame" className="h-100 position-absolute d-flex" style={{ width: `calc(100vw)` }}>
                    {(() => {
                        var images = [];
                        for (var i = 1; i <= propImageLen; i++) {
                            var j = i - Math.floor(propImageLen / 2);
                            j = (j <= 0) ? (j + propImageLen) : j;

                            images.push(
                                <div className={`propshow-image ${(i <= Math.floor(propImageLen / 2)) ? "propshow-shrink-trans" : ""}`} key={i} >
                                    <div className="propshow-image" style={{ backgroundImage: `url("/Images/infopages/${page}/propshow/${j}.jpg")`, width: "100vw" }}></div>
                                </div>
                            );
                        }
                        console.log("Images count", images.length);
                        return images;
                    })()}
                </div>
            </div>
            <div className="propshow-filter-full"> </div>

            <div className="d-flex position-absolute w-100 h-100 justify-content-between align-items-center">
                <div id="propshow-left" className="propshow-nav-but d-flex"><FaChevronLeft size="25" style={{ color: "white" }} /></div>
                <div className="d-flex align-items-center flex-column h-100 text-white">
                    <div className="title">TE KOOP</div>
                    <h1 className="propshow-subtitle1">Dit vastgoed staat in de kijker maar gebruik de vastgoedvinder om je droomwoning te vinden</h1>
                </div>
                <div id="propshow-right" className="propshow-nav-but d-flex"><FaChevronRight size="25" style={{ color: "white" }} /></div>
            </div>

            <div className="propshow-bottom mt-auto w-100 row">
                <SearchBar className="row" />

                <div className="propshow-content d-flex align-items-end">
                    <div className="col-12 col-md-7 d-flex flex-column propshow-leftcnt">
                        <div className="propshow-title-upper">
                            PROJECT IN DE KIJKER
                        </div>
                        <div className="propshow-title-lower">
                            {(text != undefined) && text[page]?.propshow?.title}
                        </div>
                        <div className="propshow-price">
                            {(text != undefined) && (((page == "news") || (page == "contact")) ? "" : "vanaf " + monetize(text[page]?.propshow?.price))}
                        </div>
                        {
                            // <div className="propshow-lower-text">
                            //     {/* zonder enorme korting */}
                            //     {(text != undefined) && text[page]?.propshow?.lowertext}
                            // </div>
                        }
                    </div>
                    <div className="col d-flex justify-content-end flex-column align-items-end propshow-more-button">
                        {/* <FancyButton middle="Vastgoed Vinder" upper="breng mij naar" lower="klik hier" /> */}
                        {/* <FancyButton middle="Gratis Magazine" upper="Ik wil graag een" lower="klik hier" bk="#3e6373" to="/magazine" /> */}
                    </div>
                </div>
            </div>
        </div>

    );
}

function monetize(x) {
    if (x == undefined) return "";
    return "€" + x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export default PropShow;